export function getEnvironmentConfig(x: string) {
  const host = window.location.host;
  let env = !host.includes("dev.payinvert") && !host.includes("localhost") ? "PROD" : "DEV";
  const basename = "REACT_APP_"
  if (env == "PROD") console.log = () => { };
  return process.env[basename + env + "_" + x];
}
